import React, { useState, useEffect } from "react";
import {
  Box,
  Text,
  Input,
  Grid,
  GridItem,
  Icon,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Select,
  Button,
  ButtonGroup,
} from "@chakra-ui/react";
import { useParams, useNavigate } from "react-router-dom";
import { getOneSupplier, updateExternalSupplier } from "../../api";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { FaEdit } from "react-icons/fa";
import { statesList } from "../../Common/utils";
import { toast } from "react-toastify";

function SupplierDetails() {
  const { id } = useParams();
  const [supplierDetail, setSupplierDetail] = useState({});
  const navigate = useNavigate();
  const [editable, setEditable] = useState(false);

  const handleEditClick = () => {
    setEditable(!editable);
  };

  const fetchSupplierDetail = async (id) => {
    const response = await getOneSupplier(id);
    setSupplierDetail(response?.data);
  };

  const handleGoBack = () => {
    navigate("/supplier");
  };

  const handleUpdateSupplier = async () => {
    const response = await updateExternalSupplier(supplierDetail, id);
    if(response?.status === "success"){
      toast.success("Supplier Updated Successfully")
      navigate("/supplier")
    }
  };

  useEffect(() => {
    fetchSupplierDetail(id);
  }, [id]);

  const handleInputChange = (e, field, isFarmer, farmerIndex, addressField) => {
    const { name, value } = e.target;
    setSupplierDetail((prevDetail) => {
      if (isFarmer) {
        const updatedFarmers = [...prevDetail.supplier_farmers];
        if (addressField) {
          updatedFarmers[farmerIndex] = {
            ...updatedFarmers[farmerIndex],
            address: {
              ...updatedFarmers[farmerIndex].address,
              [addressField]: value,
            },
          };
        } else {
          updatedFarmers[farmerIndex] = {
            ...updatedFarmers[farmerIndex],
            [name]: value,
          };
        }
        return { ...prevDetail, supplier_farmers: updatedFarmers };
      } else if (field === "address") {
        return {
          ...prevDetail,
          address: {
            ...prevDetail.address,
            [name]: value,
          },
        };
      } else if (field === "contact") {
        return {
          ...prevDetail,
          contact: {
            ...prevDetail.contact,
            [name]: value,
          },
        };
      } else {
        return { ...prevDetail, [name]: value };
      }
    });
  };

  return (
    <>
      <Box marginBottom={"2rem"}>
        <Box
          display={"flex"}
          alignItems="center"
          cursor={"pointer"}
          onClick={handleGoBack}
        >
          <IoChevronBackCircleSharp color={"#52BBFF"} size={30} />
          &nbsp;
          <Text
            //#3958DC
            color={"#52BBFF"}
            fontSize={{ base: "sm", md: "sm", lg: "md" }}
            fontWeight={"800"}
            fontFamily={"font.roboto"}
          >
            Go Back
          </Text>
        </Box>
        <Box marginTop="2rem">
          <Text
            color={"#141D43"}
            fontSize="2xl"
            fontWeight={"800"}
            fontFamily={"font.roboto"}
          >
            Supplier Details
          </Text>
          <Text color={" #3958DC"} fontSize="sm">
            Details of the Supplier
          </Text>
        </Box>
        <Box
          marginTop={"1.5rem"}
          bg={
            "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
          }
          borderTopRightRadius="100px"
          borderBottomRightRadius={"80px 80px"}
          color={"#fff"}
          padding={"10px 2rem"}
          fontWeight="700"
          marginLeft="-2rem"
          marginRight={"-2.5rem"}
          display="flex"
          alignItems="center"
          gap="1rem"
        >
          <Text>Personal Details</Text>{" "}
          <Icon
            _hover={{ cursor: "pointer" }}
            as={FaEdit}
            onClick={handleEditClick}
          />
        </Box>

        <Box
          bg="white"
          p={"1rem"}
          mt="2rem"
          borderRadius="15px"
          boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
        >
          <Box p="1rem">
            <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Name
                </Text>
                {editable ? (
                  <Input
                    name="name"
                    value={supplierDetail?.name || ""}
                    onChange={(e) => handleInputChange(e)}
                    mt="1rem"
                  />
                ) : (
                  <Text color={" #464C64"} fontSize="sm" mt="1rem">
                    {supplierDetail?.name ? supplierDetail?.name : "N/A"}
                    <Text as="span"> - {supplierDetail.type}</Text>
                  </Text>
                )}
              </GridItem>
            </Grid>
          </Box>

          <Box p="1rem">
            <Grid
              templateColumns="repeat(3, 1fr)"
              marginTop={"1rem"}
              gap={editable ? "1rem" : ""}
            >
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Email
                </Text>
                {editable ? (
                  <Input
                    name="email"
                    value={supplierDetail?.contact?.email || ""}
                    onChange={(e) => handleInputChange(e, "contact")}
                    mt="1rem"
                  />
                ) : (
                  <Text color={" #464C64"} fontSize="sm" mt="1rem">
                    {supplierDetail?.contact?.email
                      ? supplierDetail?.contact?.email
                      : "N/A"}
                  </Text>
                )}
              </GridItem>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Contact
                </Text>
                {editable ? (
                  <Input
                    name="number"
                    value={supplierDetail?.contact?.number || ""}
                    onChange={(e) => handleInputChange(e, "contact")}
                    mt="1rem"
                  />
                ) : (
                  <Text color={" #464C64"} fontSize="sm" mt="1rem">
                    {supplierDetail?.contact?.number
                      ? supplierDetail?.contact?.number
                      : "N/A"}
                  </Text>
                )}
              </GridItem>
            </Grid>
          </Box>

          <Box p="1rem">
            <Grid
              templateColumns="repeat(3, 1fr)"
              marginTop={"1rem"}
              gap={editable ? "1rem" : ""}
            >
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Address
                </Text>
                {editable ? (
                  <Input
                    name="raw_address"
                    value={supplierDetail?.address?.raw_address || ""}
                    onChange={(e) => handleInputChange(e, "address")}
                    mt="1rem"
                  />
                ) : (
                  <Text color={" #464C64"} fontSize="sm" mt="1rem">
                    {supplierDetail?.address?.raw_address
                      ? supplierDetail?.address?.raw_address
                      : "N/A"}
                  </Text>
                )}
              </GridItem>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  City
                </Text>
                {editable ? (
                  <Input
                    name="city"
                    value={supplierDetail?.address?.city || ""}
                    onChange={(e) => handleInputChange(e, "address")}
                    mt="1rem"
                  />
                ) : (
                  <Text color={" #464C64"} fontSize="sm" mt="1rem">
                    {supplierDetail?.address?.city
                      ? supplierDetail?.address?.city
                      : "N/A"}
                  </Text>
                )}
              </GridItem>
            </Grid>
          </Box>

          <Box p="1rem">
            <Grid
              templateColumns="repeat(3, 1fr)"
              marginTop={"1rem"}
              gap={editable ? "1rem" : ""}
            >
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  State
                </Text>
                {editable ? (
                  <Select
                    name="state"
                    value={supplierDetail?.address?.state || ""}
                    onChange={(e) => handleInputChange(e, "address")}
                    mt="1rem"
                  >
                    <option value="" hidden>
                      Select Your State
                    </option>
                    {statesList.map((state, index) => (
                      <option key={index} value={state}>
                        {state}
                      </option>
                    ))}
                  </Select>
                ) : (
                  <Text color={" #464C64"} fontSize="sm" mt="1rem">
                    {supplierDetail?.address?.state
                      ? supplierDetail?.address?.state
                      : "N/A"}
                  </Text>
                )}
              </GridItem>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Pin Code
                </Text>
                {editable ? (
                  <Input
                    name="pinCode"
                    value={supplierDetail?.address?.pinCode || ""}
                    onChange={(e) => handleInputChange(e, "address")}
                    mt="1rem"
                  />
                ) : (
                  <Text color={" #464C64"} fontSize="sm" mt="1rem">
                    {supplierDetail?.address?.pinCode
                      ? supplierDetail?.address?.pinCode
                      : "N/A"}
                  </Text>
                )}
              </GridItem>
            </Grid>
          </Box>
          <Box p="1rem">
            {" "}
            {editable && (
              <ButtonGroup gap="1rem">
                <Button
                  bg="#52BBFF"
                  mt="2rem"
                  w="193px"
                  h="50px"
                  color={"#fff"}
                  _hover={{ bg: "#52BBFF" }}
                  onClick={() => handleUpdateSupplier()}
                >
                  Update Supplier
                </Button>
              </ButtonGroup>
            )}
          </Box>
        </Box>

        {(supplierDetail?.type === "BROKER" ||
          supplierDetail?.type === "APMC") && (
          <>
            <Box
              marginTop={"2rem"}
              color={"#fff"}
              padding={"10px 2rem"}
              fontWeight="700"
              marginLeft="-2rem"
              bg={
                "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 15%, rgba(164,206,255,1) 100%)"
              }
              borderTopRightRadius="100px"
              borderBottomRightRadius={"80px"}
              marginRight={"-2.5rem"}
            >
              Farmer Details
            </Box>
            {supplierDetail?.supplier_farmers?.length > 0 ? (
              <>
                <Accordion allowToggle defaultIndex={[0]} mt={"1rem"}>
                  {supplierDetail?.supplier_farmers?.map((farmer, index) => (
                    <AccordionItem
                      key={index}
                      bg="white"
                      boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
                    >
                      <AccordionButton display={"flex"} alignItems={"center"}>
                        <Box
                          marginTop={"1rem"}
                          color={"black"}
                          padding={"10px 1rem"}
                          fontWeight="700"
                        >
                          Farmer Detail {index + 1}
                        </Box>
                        <AccordionIcon mt={"10px"} />
                      </AccordionButton>
                      <AccordionPanel>
                        <Box p="1rem">
                          <Grid
                            templateColumns="repeat(3, 1fr)"
                            marginTop={"1rem"}
                            gap={editable ? "1rem" : ""}
                          >
                            <GridItem colSpan={1}>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                First Name
                              </Text>

                              <Text color={"#464C64"} fontSize="sm" mt="1rem">
                                {farmer?.firstName ? farmer?.firstName : "N/A"}
                              </Text>
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Last Name
                              </Text>

                              <Text color={"#464C64"} fontSize="sm" mt="1rem">
                                {farmer?.lastName ? farmer?.lastName : "N/A"}
                              </Text>
                            </GridItem>
                          </Grid>
                        </Box>
                        <Box p="1rem">
                          <Grid
                            templateColumns="repeat(3, 1fr)"
                            marginTop={"1rem"}
                            gap={editable ? "1rem" : ""}
                          >
                            <GridItem colSpan={1}>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Village
                              </Text>

                              <Text color={"#464C64"} fontSize="sm" mt="1rem">
                                {farmer?.address?.raw_address
                                  ? farmer?.address?.raw_address
                                  : "N/A"}
                              </Text>
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                District
                              </Text>

                              <Text color={"#464C64"} fontSize="sm" mt="1rem">
                                {farmer?.address?.district
                                  ? farmer?.address?.district
                                  : "N/A"}
                              </Text>
                            </GridItem>
                          </Grid>
                        </Box>
                        <Box p="1rem">
                          <Grid
                            templateColumns="repeat(3, 1fr)"
                            marginTop={"1rem"}
                            gap={editable ? "1rem" : ""}
                          >
                            <GridItem colSpan={1}>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                State
                              </Text>

                              <Text color={"#464C64"} fontSize="sm" mt="1rem">
                                {farmer?.address?.state
                                  ? farmer?.address?.state
                                  : "N/A"}
                              </Text>
                            </GridItem>
                            <GridItem>
                              <Text
                                color={"#141D43"}
                                fontSize="md"
                                fontWeight={"700"}
                                fontFamily={"font.roboto"}
                              >
                                Pin Code
                              </Text>

                              <Text color={"#464C64"} fontSize="sm" mt="1rem">
                                {farmer?.address?.pinCode
                                  ? farmer?.address?.pinCode
                                  : "N/A"}
                              </Text>
                            </GridItem>
                          </Grid>
                        </Box>
                      </AccordionPanel>
                    </AccordionItem>
                  ))}
                </Accordion>
              </>
            ) : (
              <>
                <Box mt="1rem" textAlign="center" mb="1rem">
                  <Text
                    color={"#141D43"}
                    fontSize="md"
                    fontWeight={"700"}
                    fontFamily={"font.roboto"}
                  >
                    No farmer details for this supplier
                  </Text>
                </Box>
              </>
            )}
          </>
        )}
      </Box>
    </>
  );
}

export default SupplierDetails;
